export default function removeNullObjectKeys(obj) {
  const cleanObj = obj;
  Object.keys(cleanObj).forEach(
    key =>
      (cleanObj[key] == null || cleanObj[key] === '') && delete cleanObj[key]
  );
  return cleanObj;
}
